import { Field, getFieldValue, Item, LinkField, Text, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames/bind';
import React from 'react';
import withValidDatasourceCheck from 'lib/enhancers/withValidDatasourceCheck';

import Link from 'components/helpers/Link/Link';
import type { ComponentProps } from 'lib/component-props';
import compose from 'lib/enhancers/compose';
import withStyles from 'lib/enhancers/withStyles';
import type { RecordOfFields } from 'models/fields';

import PhotoCard, { type PhotoCardFields } from './PhotoCard';
import styles from './PhotoCardListing.module.scss';
import RichTextWrapper from 'components/helpers/RichText/RichTextWrapper';

const cx = classNames.bind(styles);

type PhotoCardListingFields = {
  children: Item[];
  description: Field<string>;
  heading: Field<string>;
  headingLevel: Item;
  headingTextStyle: Item | null;
  link: LinkField;
  linkText: Field<string>;
};

type PhotoCardListingProps = ComponentProps & {
  fields: PhotoCardListingFields;
};

const PhotoCardListing = (props: PhotoCardListingProps): React.JSX.Element => {
  const { className, fields } = props;
  const { children, description, heading, headingLevel, link, linkText } = fields;
  const { sitecoreContext } = useSitecoreContext();

  const headLvl = getFieldValue<string>(headingLevel?.fields as RecordOfFields, 'Value') || 'h2';

  const headingTextStyleItemField = fields.headingTextStyle?.fields as RecordOfFields;
  const headingTextStyleValue = getFieldValue<string>(headingTextStyleItemField, 'Value') || 'font-style-xl';

  return (
    <div className={cx('photo-listing', className)}>
      <Text
        field={heading}
        tag={headLvl}
        className={cx({ title: true, [headingTextStyleValue]: true })}
        encode={sitecoreContext.pageEditing}
      />
      <RichTextWrapper tag="div" field={description} className={cx('photo-listing-description')} />
      <div className={cx('photo-listing-container')}>
        {children?.map((item: Item, i: number) => (
          <div className={cx('photo-card-container')} key={i}>
            <PhotoCard fields={item.fields as PhotoCardFields} />
          </div>
        ))}
      </div>
      {link?.value?.href !== '' && (
        <Link
          field={link}
          className={cx('photo-listing-view-all')}
          icon="carat"
          showLinkTextWithChildrenPresent={false}
        >
          <Text field={linkText} encode={sitecoreContext.pageEditing} />
        </Link>
      )}
    </div>
  );
};

export default compose<PhotoCardListingProps>(withValidDatasourceCheck(), withStyles())(PhotoCardListing);
